<template>
  <v-dialog 
  v-model="dialog" 
  content-class="c-dialog-border-13 dialog-mod"
  scrollable
  hide-overlay
  :fullscreen="$vuetify.breakpoint.xs"
  max-width="1000px">

    <v-card v-if="dialog">
      
      <history-card :id="id" @onClose="close"></history-card>
    
    </v-card>

  </v-dialog>
</template>

<script>
import HistoryCard from './history-card'
export default {
  components: {
    HistoryCard
  },
  data () {
    return {
      id: null,
      dialog: false
    }
  },
  methods: {
    open (id) {
      this.id = id
      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  }
  
}
</script>

<style scoped lang="scss">
::v-deep .dialog-mod {
  height: 60vh;
}
</style>

